import React, { useState, useEffect, useRef } from "react";
import SteppedNumberInput from "./Reusable/NumberInputs/SteppedNumberInput";

function FOVInput(props) {
  const [inputValue, setInputValue] = useState("");
  const [lastValidValue, setLastValidValue] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (props.value !== inputValue) {
      const newValue = props.value !== undefined ? String(props.value) : "";
      setInputValue(newValue);
      setLastValidValue(newValue);
    }
  }, [props.value]);

  const handleInputChange = (e) => {
    const newValue = e.target.value;

    if (newValue === "" || newValue === "-") {
      setInputValue(newValue);
      return;
    }

    const numberValue = Number(newValue);

    if (!isNaN(numberValue)) {
      setInputValue(newValue);
      if (typeof props.onChange === "function") {
        props.onChange(numberValue);
      }
    }
  };

  const handleBlur = () => {
    if (inputValue === "" || inputValue === "-") {
      setInputValue(lastValidValue);
    } else {
      const value = parseInt(inputValue);
      let finalValue = value;
      if (isNaN(value) || value < props.min) {
        finalValue = props.min;
      } else if (value > props.max) {
        finalValue = props.max;
      }
      setInputValue(String(finalValue));
      setLastValidValue(String(finalValue));
      if (typeof props.onChange === "function") {
        props.onChange(finalValue);
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (inputRef.current) {
        inputRef.current.blur();
      }
    }
  };

  return (
    <SteppedNumberInput
      ref={inputRef}
      min={props.min}
      max={props.max}
      step="1"
      className={props.className || "SettingsValueInput"}
      style={{ width: "90px" }}
      value={inputValue}
      onChange={handleInputChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
    />
  );
}

export default FOVInput;

